import { VariantProps, cva } from 'class-variance-authority';

export const cardStyles = cva('rounded-12', {
  variants: {
    variant: {
      outlined: 'border bg-grayscale0 border-grayscale100',
      flat: 'bg-grayscale50',
      elevated: 'bg-grayscale0 shadow-2',
      info: 'bg-primary50',
    },
  },
  defaultVariants: {
    variant: 'outlined',
  },
});

export type CardStylesVariants = VariantProps<typeof cardStyles>;
